module.exports = __webpack_public_path__ + "img/74-l.1f6b08b4.png";